import { render, staticRenderFns } from "./Journal.vue?vue&type=template&id=70b4e023&scoped=true&"
import script from "./Journal.vue?vue&type=script&lang=ts&"
export * from "./Journal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b4e023",
  null
  
)

export default component.exports